export const commonEnvironment = {
  version: '0.0.0',
  forceShowInstallModal: false,
  preventFormUnload: true,
  sentry: '',
  production: false,
  updatePollingInterval: 60,
  updatePollingIntervalDelay: 10,
  firebaseConfig: {
    apiKey: '',
    authDomain: 'triarc-cloud.firebaseapp.com',
    projectId: 'triarc-cloud',
    storageBucket: 'triarc-cloud.appspot.com',
    messagingSenderId: '',
    appId: '',
  },
  enabledServiceWorker: true,
  authServerRealm: 'sereo',
  authServerClient: 'sereo-yuzu-client',
  offlineDetection: {
    intervalMs: 30000,
  },
  navbarColor: '#fafafa', // surface-50
};
